"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBPopover = _interopRequireDefault(require("../HBPopover/HBPopover"));
var _HBColorPicker = require("./HBColorPicker");
var _ColorCircleBlock = _interopRequireDefault(require("./ColorCircleBlock"));
var _useColorPickerConverter = _interopRequireDefault(require("./useColorPickerConverter"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _variables = require("../../styles/variables");
var _HBColorPickerDrawer = _interopRequireDefault(require("./HBColorPickerDrawer/HBColorPickerDrawer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBColorPickerButton = function HBColorPickerButton(_ref) {
  var _color$rgb2;
  var testIdName = _ref.testIdName,
    testId = _ref.testId,
    disableAlpha = _ref.disableAlpha,
    presetColors = _ref.presetColors,
    className = _ref.className,
    onChange = _ref.onChange,
    _ref$withActions = _ref.withActions,
    withActions = _ref$withActions === void 0 ? false : _ref$withActions,
    selectedColor = _ref.selectedColor,
    removeTransparent = _ref.removeTransparent,
    targetContainer = _ref.targetContainer,
    presetColorsTitle = _ref.presetColorsTitle,
    shouldSupportOverflowHidden = _ref.shouldSupportOverflowHidden,
    stopPropagationOnTargetClick = _ref.stopPropagationOnTargetClick,
    stopPropagationOnColorPickerClick = _ref.stopPropagationOnColorPickerClick,
    _ref$showInDrawer = _ref.showInDrawer,
    showInDrawer = _ref$showInDrawer === void 0 ? false : _ref$showInDrawer,
    onCancel = _ref.onCancel;
  var _useState = (0, _react.useState)(selectedColor),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentColor = _useState2[0],
    setCurrentColor = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    forceClose = _useState4[0],
    setForceClose = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    isOpenDrawer = _useState6[0],
    setIsOpenDrawer = _useState6[1];
  var effectiveWithActions = showInDrawer || withActions;
  var getEffectiveColor = function getEffectiveColor() {
    return effectiveWithActions ? currentColor : selectedColor;
  };
  var handleColorChange = function handleColorChange(color) {
    if (effectiveWithActions) {
      setCurrentColor(color);
    } else {
      onChange === null || onChange === void 0 || onChange(color);
    }
  };
  var _useColorPickerConver = (0, _useColorPickerConverter["default"])(getEffectiveColor(), handleColorChange),
    _onChange = _useColorPickerConver.onChange,
    color = _useColorPickerConver.color;
  var handleClose = (0, _react.useCallback)(function () {
    if (showInDrawer) {
      setIsOpenDrawer(false);
    } else {
      setForceClose(true);
    }
  }, [showInDrawer, setIsOpenDrawer, setForceClose]);
  var handleSave = (0, _react.useCallback)(function () {
    handleClose();
    if (onChange) {
      onChange(currentColor);
    }
  }, [currentColor, onChange, handleClose]);
  var handleDrawerOpen = function handleDrawerOpen() {
    setIsOpenDrawer(true);
  };
  var handleCancel = function handleCancel() {
    handleClose();
    if (effectiveWithActions) {
      // support for when no targetContainer is provided
      setCurrentColor(selectedColor);
    }
    if (onCancel) {
      onCancel();
    }
  };
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    shouldBeSelected = _useState8[0],
    setShouldBeSelected = _useState8[1];
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName,
    suffix: 'color-picker',
    componentName: 'HBColorPickerButton'
  });
  if (showInDrawer) {
    var _color$rgb;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, targetContainer ? /*#__PURE__*/_react["default"].createElement("div", {
      onClick: handleDrawerOpen
    }, targetContainer) : /*#__PURE__*/_react["default"].createElement(_ColorCircleBlock["default"], {
      testId: finalTestId,
      color: color === null || color === void 0 ? void 0 : color.rgb,
      alpha: color === null || color === void 0 || (_color$rgb = color.rgb) === null || _color$rgb === void 0 ? void 0 : _color$rgb.a,
      onClick: handleDrawerOpen,
      isSelected: isOpenDrawer
    }), /*#__PURE__*/_react["default"].createElement(_HBColorPickerDrawer["default"], {
      testId: finalTestId,
      isOpen: isOpenDrawer,
      onClose: handleCancel,
      onSave: handleSave,
      title: presetColorsTitle
    }, /*#__PURE__*/_react["default"].createElement(_HBColorPicker.HBColorPickerWithHoc, {
      showInDrawer: true,
      disableAlpha: true,
      removeTransparent: true,
      onChange: _onChange,
      selectedColor: color,
      presetColors: presetColors,
      className: className,
      stopPropagationOnColorPickerClick: true
    })));
  }
  return /*#__PURE__*/_react["default"].createElement(_HBPopover["default"], {
    target: targetContainer || /*#__PURE__*/_react["default"].createElement(_ColorCircleBlock["default"], {
      testId: finalTestId,
      color: color === null || color === void 0 ? void 0 : color.rgb,
      alpha: color === null || color === void 0 || (_color$rgb2 = color.rgb) === null || _color$rgb2 === void 0 ? void 0 : _color$rgb2.a,
      isSelected: shouldBeSelected
    }),
    openTrigger: "click",
    onOpenChange: function onOpenChange(_ref2) {
      var isOpen = _ref2.isOpen;
      setShouldBeSelected(isOpen);
      setForceClose(false);
    },
    shouldSupportClickOutside: true,
    shouldSupportCloseOnEnter: true,
    shouldSupportOverflowHidden: shouldSupportOverflowHidden,
    stopPropagationOnTargetClick: stopPropagationOnTargetClick,
    customStyle: {
      padding: 0,
      cursor: 'default',
      zIndex: _variables.Z_INDEX.POPOVER
    },
    forceClose: forceClose,
    testId: "storybook"
  }, /*#__PURE__*/_react["default"].createElement(_HBColorPicker.HBColorPickerWithHoc, {
    onChange: _onChange,
    onSaveClicked: withActions ? handleSave : undefined,
    onCancelClicked: withActions ? handleCancel : undefined,
    selectedColor: color,
    disableAlpha: disableAlpha,
    presetColors: presetColors,
    className: className,
    removeTransparent: removeTransparent,
    presetColorsTitle: presetColorsTitle,
    stopPropagationOnColorPickerClick: stopPropagationOnColorPickerClick
  }));
};
var _default = exports["default"] = HBColorPickerButton;
//# sourceMappingURL=HBColorPickerButton.js.map